import { render, staticRenderFns } from "./Apartments.vue?vue&type=template&id=679ae886&scoped=true&"
import script from "./Apartments.vue?vue&type=script&lang=ts&"
export * from "./Apartments.vue?vue&type=script&lang=ts&"
import style0 from "./Apartments.vue?vue&type=style&index=0&id=679ae886&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ae886",
  null
  
)

export default component.exports